"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrossTabBroadcast = void 0;
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = require("react");
function useCrossTabBroadcast(channel) {
    const receiveHandlerRef = (0, react_1.useRef)(noop_1.default);
    const broadcast = (0, react_1.useCallback)((message) => {
        if (typeof window !== 'undefined') {
            localStorage.setItem(channel, JSON.stringify(message));
            localStorage.removeItem(channel);
        }
    }, [channel]);
    const setHandler = (0, react_1.useCallback)((handler) => {
        receiveHandlerRef.current = handler;
    }, []);
    (0, react_1.useEffect)(() => {
        const onReceiveMessage = e => {
            const { key, newValue } = e;
            if (key === channel) {
                const parsedValue = JSON.parse(newValue);
                if (!parsedValue) {
                    return;
                }
                receiveHandlerRef.current(parsedValue);
            }
        };
        window.addEventListener('storage', onReceiveMessage);
        return () => {
            window.removeEventListener('storage', onReceiveMessage);
        };
    }, [channel]);
    return { broadcast, setHandler };
}
exports.useCrossTabBroadcast = useCrossTabBroadcast;
//# sourceMappingURL=useCrossTabBroadcast.js.map